// PBG interaction tracking for ABLyft goals, loaded on PDP from ablyft-init.liquid
// pbg-interaction-all: every user slide change (swipe, thumbnail, arrow, click) and every zoom open

const INTERACTION_GOAL = 'pbg-interaction-all';
const GALLERY_SELECTOR = '[id$="__main"] product-gallery';
// max time between a gesture on the gallery and the slide change it caused
const GESTURE_WINDOW_MS = 1500;
// keydown stays unfiltered: Enter/Space activate thumbnails and arrows without a pointerdown
const GESTURE_EVENTS = ['pointerdown', 'touchmove', 'wheel', 'keydown'];

let lastGestureAt = 0;

function pushGoal(goalName) {
	window.ablyft = window.ablyft || [];
	window.ablyft.push({ eventType: 'custom', eventName: goalName });
}

function isInsideMainGallery(event) {
	return event.target instanceof Element && Boolean(event.target.closest(GALLERY_SELECTOR));
}

function recordGalleryGesture(event) {
	if (isInsideMainGallery(event)) {
		lastGestureAt = Date.now();
	}
}

// Variant switches can change slides programmatically.
// only count slide changes shortly after a user gesture on the gallery.
function onSlideChange(event) {
	if (!isInsideMainGallery(event)) return;

	if (Date.now() - lastGestureAt < GESTURE_WINDOW_MS) {
		pushGoal(INTERACTION_GOAL);
	}
}

function onLightboxOpen(event) {
	if (isInsideMainGallery(event)) {
		pushGoal(INTERACTION_GOAL);
	}
}

const listenerOptions = { capture: true, passive: true };

GESTURE_EVENTS.forEach((eventName) => {
	document.addEventListener(eventName, recordGalleryGesture, listenerOptions);
});

document.addEventListener('carousel:change', onSlideChange, listenerOptions);
document.addEventListener('lightbox:open', onLightboxOpen, listenerOptions);
